module.exports = "<p><span class=\"titulo\">YaServicios<sup class=\"beta\">BETA</sup>&nbsp;</span><span class=\"flag-icon flag-icon-cl\"></span> &nbsp;|&nbsp; {{ hoy | date:'dd/MM/y H:mm' }}</p>"


//////////////////
// WEBPACK FOOTER
// ./src/app/ui/fecha/fecha.component.html
// module id = ./src/app/ui/fecha/fecha.component.html
// module chunks = main